import React, { useState } from "react";

import { FormButton } from "components";

import { Form, Formik } from "formik";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    rowSelected,
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { handleResponse } from "services/Local-services";
import { SFHotelAdminDel } from "services/services-mia/SFHotel/SFHotelAdminDel";

export default function DeleteModal({ updateList, closeModal, employee }) {
    const setSelected = useSetRecoilState(rowSelected);
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);

    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async () => {
        setInRequest(true);

        const response = await SFHotelAdminDel({
            msuAdicionalId: employee.id
        }, credentials);

        const functions = {
            setSnackbarInfo,
            setIsOpen: closeModal,
            setSelected,
            updateList,
        };

        handleResponse(
            response,
            "El administrador ha sido eliminado exitosamente",
            functions
        );

        setInRequest(false);
    };

    return (
        <Formik
            initialValues={{
                nombre: employee.usuarioNombreCompleto,
            }}
            onSubmit={(_, { setSubmitting }) => {
                try {
                    handleSubmit();
                } catch (e) {
                    setSnackbarInfo({
                        message: e.errmsg,
                        severity: "error",
                        open: true,
                    });
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            <Form
                className={styles.inputs}
                noValidate
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "0em"
                }}
            >
                <div className={styles["column-sm"]} style={{ maxWidth: "450px", gap: "0.2em" }}>

                    <h2 style={{ textAlign: "center", margin: "1em 0 0.8em 0", lineHeight: "1.3" }}>
                        Estás por eliminar al administrador <br />
                        <span style={{ fontSize: "1.1em", fontWeight: "bold" }}>
                            {employee.usuarioNombres + " " + employee.usuarioApellidos}
                        </span>
                    </h2>
                    <h3 style={{
                        textAlign: "center",
                        margin: "0",
                        fontWeight: 500,
                        color: "#000000ff",
                        fontSize: "",
                        lineHeight: "1.4"
                    }}>
                        Una vez eliminado, no podrás recuperarlo. <br /> ¿Querés continuar?
                    </h3>

                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Confirmar" }}
                        onCloseModal={closeModal}
                    />

                </div>
            </Form>
        </Formik>
    );
}